import React from "react";
import {PageSection} from "../../contenful/types";
import './styles/Section.scss';
import {documentToReactComponents} from "@contentful/rich-text-react-renderer";
import ReactMarkdown from "react-markdown";
import {DefaultMarkdownRenderComponents} from "../../contentutils";

interface ColumnProps {
    section: PageSection;
}

const ColumnText = (props: ColumnProps) => {
    let stringType = typeof props.section?.text === "string"
    return (
        <div className={props.section.image === undefined ? `${"columnText"} ${"fullColumnText"}` : "columnText" } style={{color: props.section.textColor}}>
            {
              !stringType &&  documentToReactComponents(props.section.text as any)
            }
            { stringType && <ReactMarkdown components={DefaultMarkdownRenderComponents} >{props.section.text}</ReactMarkdown>
            }
        </div>
    )
}

const ColumnImage = (props: ColumnProps) => {
    const url:string = props.section.image && props.section.image.fields.file.url || "";
    const width:string = props.section.image && props.section.image.fields.file.details.image.width || "";
    const height:string = props.section.image && props.section.image.fields.file.details.image.height || "";
    const imgName = props.section.image && props.section.image.fields.title
    return (
        <div className="columnImage">
            <div className={`image-2 ${imgName}`}></div>
            <img alt="column" src={url} width={width} height={height} />
        </div>
    )
}

const Row = (props: Props) => {
    return (
        <div className={"row"}>
            {
                props.section.image === undefined
                    ? (
                        <ColumnText section={props.section} />
                    )
                    : (
                        <React.Fragment>
                            {
                                props.mobile
                                    ? (
                                        <React.Fragment>
                                            <ColumnImage section={props.section} />
                                            <ColumnText section={props.section} />
                                        </React.Fragment>
                                    )
                                    : props.section.imageLeftSide
                                        ? (<React.Fragment>
                                            <ColumnImage section={props.section} />
                                            <ColumnText section={props.section} />
                                        </React.Fragment>)
                                        : (<React.Fragment>
                                            <ColumnText section={props.section} />
                                            <ColumnImage section={props.section} />
                                        </React.Fragment>)
                            }
                        </React.Fragment>
                    )
            }
        </div>
    )
}

interface Props {
    section: PageSection;
    mobile: boolean;
}

const PageSectionComponent = (props: Props) => {
    const classNameContentful = props.section.cssClassName ? props.section.cssClassName : ''
    return (
        <div className={`page-section section ${props.section.name} ${classNameContentful}`} style={{borderColor: props.section.borderColor, backgroundColor: props.section.backgroundColor}}>
            <Row mobile={props.mobile} section={props.section}/>
        </div>
    )
}

export default PageSectionComponent;